// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2hpAv","label":"LabeledBox_label__35Cf8"};